(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-compose-runtime-runtime.js', './androidx-lifecycle-lifecycle-common.js', './kotlin-kotlin-stdlib.js', './androidx-lifecycle-lifecycle-runtime.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-compose-runtime-runtime.js'), require('./androidx-lifecycle-lifecycle-common.js'), require('./kotlin-kotlin-stdlib.js'), require('./androidx-lifecycle-lifecycle-runtime.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime-compose'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'androidx-lifecycle-lifecycle-runtime-compose'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime-compose'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'androidx-lifecycle-lifecycle-runtime-compose'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime-compose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-lifecycle-lifecycle-runtime-compose'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime-compose'. Its dependency 'androidx-lifecycle-lifecycle-runtime' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime' is loaded prior to 'androidx-lifecycle-lifecycle-runtime-compose'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-runtime-compose'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'androidx-lifecycle-lifecycle-runtime-compose'.");
    }
    globalThis['androidx-lifecycle-lifecycle-runtime-compose'] = factory(typeof globalThis['androidx-lifecycle-lifecycle-runtime-compose'] === 'undefined' ? {} : globalThis['androidx-lifecycle-lifecycle-runtime-compose'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-lifecycle-lifecycle-runtime'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_lifecycle_lifecycle_common, kotlin_kotlin, kotlin_androidx_lifecycle_lifecycle_runtime, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var State_RESUMED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.n;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.p;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var State_INITIALIZED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.m;
  var State_DESTROYED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.l;
  var LifecycleRegistry_init_$Create$ = kotlin_androidx_lifecycle_lifecycle_runtime.$_$.b;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var LifecycleEventObserver = kotlin_androidx_lifecycle_lifecycle_common.$_$.a;
  var hashCode = kotlin_kotlin.$_$.bg;
  var VOID = kotlin_kotlin.$_$.d;
  var Event_ON_DESTROY_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.f;
  var Event_ON_RESUME_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.h;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ComposeLifecycleOwner, 'ComposeLifecycleOwner', ComposeLifecycleOwner);
  initMetadataForClass(sam$androidx_lifecycle_LifecycleEventObserver$0, 'sam$androidx_lifecycle_LifecycleEventObserver$0', VOID, VOID, [LifecycleEventObserver, FunctionAdapter]);
  initMetadataForClass(rememberLifecycleOwner$$inlined$cache$1$2);
  initMetadataForLambda(rememberLifecycleOwner$slambda, CoroutineImpl, VOID, [1]);
  //endregion
  var androidx_lifecycle_compose_LifecycleStartStopEffectScope$stable;
  var androidx_lifecycle_compose_LifecycleResumePauseEffectScope$stable;
  function rememberLifecycleOwner(maxLifecycle, parent, $composer, $changed, $default) {
    var maxLifecycle_0 = {_v: maxLifecycle};
    var parent_0 = {_v: parent};
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -1501509168, 'C(rememberLifecycleOwner)77@3569L7,79@3628L44,82@3787L899,82@3741L945,107@4812L68,107@4762L118:RememberLifecycleOwner.kt#2vxrgp');
    if (!(($default & 1) === 0)) {
      maxLifecycle_0._v = State_RESUMED_getInstance();
    }
    if (!(($default & 2) === 0)) {
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalLifecycleOwner();
      var $composer_1 = $composer_0;
      parent_0._v = $composer_1.u31(this_0);
    }
    if (isTraceInProgress()) {
      traceEventStart(-1501509168, $changed, -1, 'androidx.lifecycle.compose.rememberLifecycleOwner (RememberLifecycleOwner.kt:78)');
    }
    sourceInformationMarkerStart($composer_0, 158706556, 'CC(remember):RememberLifecycleOwner.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(parent_0._v);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new ComposeLifecycleOwner();
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    var localLifecycleOwner = tmp1_group;
    var tmp_0 = parent_0._v;
    sourceInformationMarkerStart($composer_0, 158712499, 'CC(remember):RememberLifecycleOwner.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_0 = !!($composer_0.q31(localLifecycleOwner) | $composer_0.q31(parent_0._v));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
      var value_0 = rememberLifecycleOwner$lambda(parent_0, localLifecycleOwner);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp2_group = tmp_1;
    sourceInformationMarkerEnd($composer_0);
    DisposableEffect(localLifecycleOwner, tmp_0, tmp2_group, $composer_0, 112 & $changed);
    var tmp_2 = maxLifecycle_0._v;
    sourceInformationMarkerStart($composer_0, 158744468, 'CC(remember):RememberLifecycleOwner.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid_1 = !!($composer_0.q31(localLifecycleOwner) | (($changed & 14 ^ 6) > 4 && $composer_0.m31(maxLifecycle_0._v.a1_1) || ($changed & 6) === 4));
    // Inline function 'kotlin.let' call
    var it_1 = $composer_0.i31();
    var tmp_3;
    if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
      var value_1 = rememberLifecycleOwner$slambda_0(localLifecycleOwner, maxLifecycle_0, null);
      $composer_0.j31(value_1);
      tmp_3 = value_1;
    } else {
      tmp_3 = it_1;
    }
    var tmp3_group = tmp_3;
    sourceInformationMarkerEnd($composer_0);
    LaunchedEffect(localLifecycleOwner, tmp_2, tmp3_group, $composer_0, 112 & $changed << 3);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return localLifecycleOwner;
  }
  function updateLifecycleState($this) {
    var tmp;
    if ($this.s8s_1.a1_1 < $this.t8s_1.a1_1) {
      tmp = $this.s8s_1;
    } else {
      tmp = $this.t8s_1;
    }
    var targetState = tmp;
    if ($this.r8s_1.v70().equals(State_INITIALIZED_getInstance()) && targetState.equals(State_DESTROYED_getInstance())) {
      return Unit_instance;
    }
    $this.r8s_1.x7n(targetState);
  }
  function ComposeLifecycleOwner() {
    this.r8s_1 = LifecycleRegistry_init_$Create$(this);
    this.s8s_1 = State_INITIALIZED_getInstance();
    this.t8s_1 = State_INITIALIZED_getInstance();
  }
  protoOf(ComposeLifecycleOwner).w7m = function () {
    return this.r8s_1;
  };
  protoOf(ComposeLifecycleOwner).u8s = function (value) {
    this.t8s_1 = value;
    updateLifecycleState(this);
  };
  protoOf(ComposeLifecycleOwner).y7n = function (event) {
    this.s8s_1 = event.o70();
    updateLifecycleState(this);
  };
  function sam$androidx_lifecycle_LifecycleEventObserver$0(function_0) {
    this.v8s_1 = function_0;
  }
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).j70 = function (source, event) {
    return this.v8s_1(source, event);
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).q3 = function () {
    return this.v8s_1;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LifecycleEventObserver) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function rememberLifecycleOwner$lambda$lambda($localLifecycleOwner) {
    return function (_unused_var__etf5q3, event) {
      $localLifecycleOwner.y7n(event);
      return Unit_instance;
    };
  }
  function rememberLifecycleOwner$$inlined$cache$1$2($parent, $observer, $localLifecycleOwner) {
    this.w8s_1 = $parent;
    this.x8s_1 = $observer;
    this.y8s_1 = $localLifecycleOwner;
  }
  protoOf(rememberLifecycleOwner$$inlined$cache$1$2).s1d = function () {
    var tmp0_safe_receiver = this.w8s_1._v;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w7m();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.u70(this.x8s_1);
    }
    this.y8s_1.y7n(Event_ON_DESTROY_getInstance());
  };
  function rememberLifecycleOwner$lambda($parent, $localLifecycleOwner) {
    return function ($this$DisposableEffect) {
      var tmp = rememberLifecycleOwner$lambda$lambda($localLifecycleOwner);
      var observer = new sam$androidx_lifecycle_LifecycleEventObserver$0(tmp);
      var tmp0_safe_receiver = $parent._v;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w7m();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.t70(observer);
      }
      var tmp_0;
      if ($parent._v == null) {
        $localLifecycleOwner.y7n(Event_ON_RESUME_getInstance());
        tmp_0 = Unit_instance;
      }
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new rememberLifecycleOwner$$inlined$cache$1$2($parent, observer, $localLifecycleOwner);
    };
  }
  function rememberLifecycleOwner$slambda($localLifecycleOwner, $maxLifecycle, resultContinuation) {
    this.h8t_1 = $localLifecycleOwner;
    this.i8t_1 = $maxLifecycle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberLifecycleOwner$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberLifecycleOwner$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberLifecycleOwner$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.h8t_1.u8s(this.i8t_1._v);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rememberLifecycleOwner$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new rememberLifecycleOwner$slambda(this.h8t_1, this.i8t_1, completion);
    i.j8t_1 = $this$LaunchedEffect;
    return i;
  };
  function rememberLifecycleOwner$slambda_0($localLifecycleOwner, $maxLifecycle, resultContinuation) {
    var i = new rememberLifecycleOwner$slambda($localLifecycleOwner, $maxLifecycle, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function get_LocalLifecycleOwner() {
    _init_properties_LocalLifecycleOwner_nonAndroid_kt__hguocc();
    return LocalLifecycleOwner;
  }
  var LocalLifecycleOwner;
  function LocalLifecycleOwner$lambda() {
    _init_properties_LocalLifecycleOwner_nonAndroid_kt__hguocc();
    // Inline function 'kotlin.error' call
    var message = 'CompositionLocal LocalLifecycleOwner not present';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  var properties_initialized_LocalLifecycleOwner_nonAndroid_kt_9cr6oy;
  function _init_properties_LocalLifecycleOwner_nonAndroid_kt__hguocc() {
    if (!properties_initialized_LocalLifecycleOwner_nonAndroid_kt_9cr6oy) {
      properties_initialized_LocalLifecycleOwner_nonAndroid_kt_9cr6oy = true;
      LocalLifecycleOwner = staticCompositionLocalOf(LocalLifecycleOwner$lambda);
    }
  }
  //region block: init
  androidx_lifecycle_compose_LifecycleStartStopEffectScope$stable = 8;
  androidx_lifecycle_compose_LifecycleResumePauseEffectScope$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_LocalLifecycleOwner;
  _.$_$.b = rememberLifecycleOwner;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-lifecycle-lifecycle-runtime-compose.js.map
